import { FC, ReactElement } from 'react';

import { Link } from 'react-router-dom';

import { Address, Picture } from '../../../../../components';
import { LinkTarget } from '../../../../../entities/Link/Link';
import { Store } from '../../../../../entities/Store/Store';
import { getLinkGoogleMapToStore } from '../../../../../helpers/linkGoogleMapToStore';
import { useTrans } from '../../../../../hooks';
import { StoreDetailHeaderSkeletons } from '../../skeletons';
import { StoreHours } from '../StoreHours/StoreHours';

import './StoreDetailHeader.scss';

interface StoreDetailHeaderProps {
    isLoading?: boolean;
    store?: Store;
    className?: string;
}

export const StoreDetailHeader: FC<StoreDetailHeaderProps> = ({
    isLoading,
    store,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    if (isLoading || !store) {
        return (
            <StoreDetailHeaderSkeletons className={className} />
        );
    }

    const linkToGoogleMapsStore = getLinkGoogleMapToStore(store);

    return (
        <header className={`store-detail-header ${className}`}>
            {store.image && (
                <Picture
                    {...store.image}
                    alt={store.image.alt || store.title}
                    className="store-detail-header__image"
                />
            )}

            <div className="store-detail-header__info">
                <h4 className="store-detail-header__info-title">
                    {store.title}
                </h4>

                <Address
                    address={store.address}
                    className="store-detail-header__address"
                >
                    <Link
                        to={linkToGoogleMapsStore}
                        target={LinkTarget.blank}
                        rel="noreferrer"
                        className="store-detail-header__route-link"
                    >
                        {trans('containers.storeDetail.routeLink')}
                    </Link>
                </Address>

                <StoreHours
                    openingHours={store.openingHours}
                    adjustedOpeningHours={store.adjustedOpeningHours}
                />
            </div>
        </header>
    );
};
